import { render, staticRenderFns } from "./ClaimCreator.vue?vue&type=template&id=bfdd59f8&"
import script from "./ClaimCreator.vue?vue&type=script&lang=js&"
export * from "./ClaimCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports